import BigNumber from 'bignumber.js';
import { useMemo } from 'react';

export function useBigNumber(value: undefined): undefined;
export function useBigNumber(value: BigNumber.Value): BigNumber;
export function useBigNumber(
  value: BigNumber.Value | undefined,
): BigNumber | undefined;

export function useBigNumber(
  value: BigNumber.Value | undefined,
): BigNumber | undefined {
  const stringValue = value?.toString();

  const bN = useMemo(
    () => (stringValue !== undefined ? new BigNumber(stringValue) : undefined),
    [stringValue],
  );

  return bN;
}
